import 'bootstrap';

import { createAlerts } from '@xolo/common/alerts'
import Form from './modules/forms'
import Layout from './modules/layout'
import { createLogin } from '@xolo/common/login'
import { onTabClick, onInit } from './modules/login-extensions'
import Navigation from './modules/navigation'
import Modals from './modules/modals'
import Plugins from '@xolo/common/plugins'
import Progress from '@xolo/common/progress'
import { createSession } from '@xolo/common/session'
import Translations from '@xolo/common/translations'
import Utility from '@xolo/common/utility'
import VideoPlayer from '@xolo/common/video'

const Alert = createAlerts({
    removeButton: '<i class="icon-close-small position-absolute remove-alert" style="right:24px"></i>',
    appendTo: ($alert) => $alert.find('.d-flex')
});
window.Alert = Alert;
window.Form = Form;
window.Navigation = Navigation;
window.Plugins = Plugins;
window.Progress = Progress;
window.Layout = Layout;
const Login = createLogin({
    csrfUrl: $("meta[name='_root_url']").attr("content") + $("meta[name='_domain']").attr("content") + '/csrf',
    onTabClick,
    onInit
});
window.Login = Login;
window.Modals = Modals;
const Session = createSession({
    onLogout: () => Utility.logout(),
    translations: Translations
});
window.Session = Session;
window.Utility = Utility;
window.VideoPlayer = VideoPlayer;

$(function(){
    Alert.init();
    Form.init();
    Navigation.init();
    Plugins.init();
    Layout.init();
    Login.init();
    Modals.init();
    Plugins.init();
    Progress.init();
    Session.init();
    Utility.init();
    VideoPlayer.init();
});
